import { useState, useEffect } from 'react'

export const useStatus = (files, loadedFiles) => {
  const [countErrorFiles, setCountErrorFiles] = useState(0)
  const [status, setStatus] = useState('loading') //loading, error, success
  const [percentUploadFiles, setPercentUploadFiles] = useState(0)

  const getLoadedFilesPercent = () =>
    Math.round((loadedFiles.length * 100) / files.length)

  useEffect(() => {
    updateStatus()
  }, [files, loadedFiles])

  const updateStatus = () => {
    const errorFiles = loadedFiles.filter(file => file.status === 'error')

    if (loadedFiles.length === files.length && loadedFiles.length > 0) {
      setStatus('success')
    }
    if (errorFiles.length > 0) {
      setStatus('error')
      setCountErrorFiles(errorFiles.length)
    }
  }

  useEffect(() => {
    setPercentUploadFiles(getLoadedFilesPercent)
  }, [files, loadedFiles])

  return {
    status,
    percentUploadFiles,
    countErrorFiles,
  }
}
